import { RootState } from "src/redux/store";

export const dashboardLayoutCountSelector = (state: RootState) => state.dashboardStore.counts;
